import { Directive } from '@angular/core';
import { ElementRef, Input, Renderer2, OnInit } from '@angular/core';

/**
 * A directive to auto-collapse long text.
 */
@Directive({
	selector: '[ddTextCollapse]'
})
export class TextCollapseDirective implements OnInit {
	@Input() ddTextCollapseText: string = '';
	@Input() ddTextCollapseMaxLength: number = 100;

	private collapsed: boolean = true;

	constructor(private el: ElementRef, private renderer: Renderer2) { }

	ngOnInit() {
//		console.log("TextCollapseDirective:", this.ddTextCollapseText, this.ddTextCollapseMaxLength);
		this.applyCollapse();
	}

	ngOnChanges() {
		this.applyCollapse();
	}

	private applyCollapse(): void {
		if (!this.ddTextCollapseText) return;

		const element = this.el.nativeElement;
		element.innerHTML = '';

		const cleanedHtml = this.stripAllExceptMark(this.ddTextCollapseText);

		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = cleanedHtml;
		const visibleText = tempDiv.textContent || '';

		if (this.ddTextCollapseMaxLength > 0 && visibleText.length > this.ddTextCollapseMaxLength) {
			const [firstHtml, secondHtml] = this.splitHtmlKeepingMark(cleanedHtml, this.ddTextCollapseMaxLength);

			const firstSpan = this.renderer.createElement('span');
			firstSpan.innerHTML = firstHtml;
			element.appendChild(firstSpan);

			const secondSpan = this.renderer.createElement('span');
			secondSpan.innerHTML = secondHtml;
			secondSpan.style.display = this.collapsed ? 'none' : 'inline';
			element.appendChild(secondSpan);

			const dots = this.renderer.createElement('span');
			dots.textContent = '...';
			dots.style.display = this.collapsed ? 'inline' : 'none';
			element.appendChild(dots);

			const toggle = this.renderer.createElement('span');
			toggle.textContent = this.collapsed ? ' more' : ' less';
			toggle.className = 'collapse-text-toggle';
			toggle.style.color = 'blue';
			toggle.style.cursor = 'pointer';
			toggle.onclick = () => {
				this.collapsed = !this.collapsed;
				this.applyCollapse();
			};
			element.appendChild(toggle);
		} else {
			const span = this.renderer.createElement('span');
			span.innerHTML = cleanedHtml;
			element.appendChild(span);
		}
	}

	private stripAllExceptMark(input: string): string {
		return input.replace(/<(?!\/?mark\b)[^>]*>/gi, '');
	}

	private splitHtmlKeepingMark(html: string, maxChars: number): [string, string] {
		const div = document.createElement('div');
		div.innerHTML = html;

		let charCount = 0;
		let finished = false;

		const first: string[] = [];
		const second: string[] = [];

		const walk = (nodes: NodeListOf<ChildNode>, target: string[]) => {
			for (let node of nodes) {
				if (finished) {
					if (node instanceof Element) {
						second.push(node.outerHTML);
					} else {
						second.push(node.textContent || '');
					}
					continue;
				}

				if (node.nodeType === Node.TEXT_NODE) {
					const text = node.textContent || '';
					if (charCount + text.length <= maxChars) {
						target.push(text);
						charCount += text.length;
					} else {
						const slice = text.slice(0, maxChars - charCount);
						target.push(slice);
						second.push(text.slice(slice.length));
						finished = true;
						break;
					}
				} else if (
					node.nodeType === Node.ELEMENT_NODE &&
					(node as HTMLElement).tagName.toLowerCase() === 'mark'
				) {
					const opening = '<mark>';
					const closing = '</mark>';

					target.push(opening);
					const innerTarget = finished ? second : target;
					walk(node.childNodes, innerTarget);
					target.push(closing);
				}
			}
		};

		walk(div.childNodes, first);

		return [first.join(''), second.join('')];
	}
}
